import * as THREE from 'three';

export let GPTextureRenderer = {
    scene: null,
    camera: null,
    renderer: null,
    canvas: null,
    width: null,
    height: null,

    initScene: function () {
        GPTextureRenderer.width = GP.project.sizeX;
        GPTextureRenderer.height = GP.project.sizeY;

        GPTextureRenderer.canvas = document.createElement('canvas');
        GPTextureRenderer.canvas.width = GPTextureRenderer.width;
        GPTextureRenderer.canvas.height = GPTextureRenderer.height;
        GPTextureRenderer.canvas.style.display = "none";

        GPTextureRenderer.scene = new THREE.Scene();
        GPTextureRenderer.camera = new THREE.PerspectiveCamera(10, 1, 0.1, 2000);
        GPTextureRenderer.scene.background = null;

        if (!GPTextureRenderer.renderer)
            GPTextureRenderer.renderer = new THREE.WebGLRenderer({canvas: GPTextureRenderer.canvas, alpha: true, antialias: true});
        GPTextureRenderer.renderer.setSize(GPTextureRenderer.width, GPTextureRenderer.height);
    },

    disposeScene: function () {
        GPTextureRenderer.canvas.width = 0;
        GPTextureRenderer.canvas.height = 0;
        GPTextureRenderer.canvas = null;

        GPTextureRenderer.scene = null;
        GPTextureRenderer.camera = null;
        GPTextureRenderer.renderer = null;
    },


    getImageContext: function (src) {
        return new Promise((resolve, reject) => {
        let img = new Image();
            img.onload = function(){
                let can = document.createElement('canvas');
                can.width = GPTextureRenderer.width;
                can.height = GPTextureRenderer.height;
                let ctx = can.getContext('2d');
                ctx.drawImage(img, 0, 0);

                resolve({canvas: can, context: ctx});
            };
            img.src = src;
        })
    },

    renderTextureToPNG: async function(url, designWidth, rotation, zoom) {
        GPTextureRenderer.initScene();

        function loadTexture(url) {return new Promise((resolve) => {
             new THREE.TextureLoader().load( url, resolve);
        })};

        const texture = await loadTexture(url);

        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.anisotropy = 4;

        texture.rotation = rotation;
        texture.repeat.set( 3.5 * designWidth / zoom, 3.5 * designWidth / zoom);

        const geometry = new THREE.PlaneGeometry(20,20);
        geometry.lookAt(new THREE.Vector3(0, 1, 0));
        const material = new THREE.MeshBasicMaterial( { map: texture } );
        material.map.minFilter = THREE.LinearFilter;
        const cube = new THREE.Mesh( geometry, material );
        GPTextureRenderer.scene.add( cube );

        GPTextureRenderer.camera.position.x = 0;
        GPTextureRenderer.camera.position.z = -10;
        GPTextureRenderer.camera.position.y = 2;
        GPTextureRenderer.camera.lookAt(0, -2.5, 0);
        GPTextureRenderer.camera.fov = 40;
        GPTextureRenderer.camera.updateProjectionMatrix();
        GPTextureRenderer.renderer.render(GPTextureRenderer.scene, GPTextureRenderer.camera);

        let png = GPTextureRenderer.renderer.domElement.toDataURL('image/webp');

        GPTextureRenderer.scene.remove(cube);
        GPTextureRenderer.disposeScene();

        return png;
    },


}
